<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<h3 class="title mb_16">
					{{ $t('rtr_activity-invoice.title') }}
				</h3>
				<!-- date -->
				<div class="d_flex mb_8">
					<div class="info mr_8">
						<date-picker
							is-required
							v-model="startDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										:value="inputValue"
										v-on="inputEvents"
									/>
								</label>
							</template>
						</date-picker>
					</div>
					<div class="info">
						<date-picker
							is-required
							v-model="endDate"
							:model-config="{ type: 'string' }"
							:locale="$store.state.common.locale"
						>
							<template v-slot="{ inputValue, inputEvents }">
								<label class="calendar_area">
									<input
										class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
										id="calendar_area"
										:value="inputValue"
										v-on="inputEvents"
									/>
								</label>
							</template>
						</date-picker>
					</div>
				</div>
				<!-- 자산선택 -->
				<div class="select_area mb_8">
					<select
						v-model="accountSeq"
						class="asset_area"
						@change="loadInvoiceList('pageInit')"
					>
						<option :value="null">
							{{ $t('input.placeholder.all_assets') }}
						</option>
						<option v-for="item in accounts" :key="item.seq" :value="item.seq">
							{{ item.asset_title }}
						</option>
					</select>
					<span class="select_icon"></span>
				</div>
				<div v-if="invoiceList.length > 0">
					<ul>
						<li
							class="list_item_box"
							v-for="item in invoiceList"
							:key="item.seq"
						>
							<div class="mb_4">
								<span class="list_num_m">{{ item._no }}</span>
							</div>
							<div class="list_item mb_4">
								<p class="fs_14">
									{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
								</p>
							</div>
							<div class="list_item mb_8">
								<p>{{ $t('rtr_activity-invoice.request_asset') }}</p>
								<div class="asset_box">
									<span :class="'small ' + item.asset_code"></span>
									<p class="code mr_4">{{ item.asset_code }}</p>
									<p class="name">{{ item.asset_title }}</p>
								</div>
							</div>
							<div class="list_item mb_8">
								<p>{{ $t('rtr_activity-invoice.request_amount') }}</p>
								<div class="num_unit type01">
									<p class="num">{{ item.net_amount }}</p>
									<p class="unit">{{ item.asset_code }}</p>
								</div>
							</div>
							<div class="list_item mb_4">
								<p>{{ $t('rtr_activity-invoice.target') }}</p>
								<p>{{ item.applicant_email_address }}</p>
							</div>
							<div class="list_item">
								<p>{{ $t('rtr_activity-invoice.item') }}</p>
								<p>{{ item.title }}</p>
							</div>
							<!--						<div class="list_item">-->
							<!--							<p>{{ $t('rtr_activity-invoice.due_date') }}</p>-->
							<!--							<p>2022.11.05</p>-->
							<!--						</div>-->
						</li>
					</ul>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
				<div class="list_none" v-else>
					<span class="ERRORGRAY"></span>
					<p>{{ $t('rtr_activity-invoice.empty') }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { commonError } from '@/common/dialog';
import { fetchInvoiceList } from '@/api/deposit';
import { mapGetters } from 'vuex';
import '@/assets/css/activity.m.css';

export default {
	name: 'Invoice.m',
	components: { Pagination },
	data() {
		return {
			startDate: this.$dayjs(new Date()).add(-1, 'month').toDate(),
			endDate: new Date(),
			accountSeq: null,
			invoiceList: [],
			curPage: 1,
			listCount: 10,
			pageNavigation: {},
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
	},
	watch: {
		startDate() {
			this.loadInvoiceList('pageInit');
		},
		endDate() {
			this.loadInvoiceList('pageInit');
		},
	},
	created() {
		if (this.$route.query.accountSeq) {
			this.accountSeq = this.$route.query.accountSeq;
		}
		this.init();
	},
	methods: {
		init() {
			this.loadInvoiceList();
		},
		async loadInvoiceList(type) {
			if (type === 'pageInit') {
				this.curPage = 1;
			}
			const params = {
				account_seq: this.accountSeq,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchInvoiceList(params).catch(
				commonError,
			);

			this.invoiceList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadInvoiceList();
		},
	},
};
</script>
<style scoped></style>
